import { gql } from '@apollo/client';

export const UNPUBLISH_WORKSPACE_FORM = gql`
  mutation UnpublishWorkspaceForm($id: ID!) {
    workspaceForm: unpublishWorkspaceForm(id: $id) {
      id
      published
    }
  }
`;
